import React from 'react';
import { MultiPortfolioReviewComponents } from './components/common/MultiPortfolioReviewComponents';
import { MultiProFormaReviewComponents } from './components/specialized/MultiProFormaReviewComponents';

export const MultiProFormaReviewStep = () => {
  return (
    <>
      <MultiPortfolioReviewComponents.Content>
        <MultiPortfolioReviewComponents.LeftSideBar />
        <MultiPortfolioReviewComponents.RightSideBar>
          <MultiProFormaReviewComponents.RightPane.ErrorBanner />
          <MultiProFormaReviewComponents.RightPane.Content />
          <MultiProFormaReviewComponents.RightPane.FooterErrorBanner />
        </MultiPortfolioReviewComponents.RightSideBar>
      </MultiPortfolioReviewComponents.Content>
      <MultiProFormaReviewComponents.Footer />
      <MultiProFormaReviewComponents.ConfirmationModal />
    </>
  );
};
